import {
  REQUEST_PRESCRIPTION_PAGE,
  UPLOAD_PRESCRIPTION_PAGE,
} from '@shared/actionLinks/pages.js'

// Outside appModule, so none of its hooks (auth, corporate, onboarding) run. Without meta.name,
// the router tracks no screen view. The static paths outrank /:corporate_key.
const route = (page, component) => ({
  path: `/${page.path}`,
  name: page.routeName,
  component,
  meta: { public: true },
})

export default [
  route(
    UPLOAD_PRESCRIPTION_PAGE,
    () => import('@eu/app/views/UploadPrescriptionLink.vue'),
  ),
  route(
    REQUEST_PRESCRIPTION_PAGE,
    () => import('@eu/app/views/RequestPrescriptionLink.vue'),
  ),
]
